export const promisifyVoid = (t: Promise<unknown>) => t.then(() => {})
